import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { 
  ODataClient,
  ODataEntityService, 
  ODataEntity, 
  ODataEntities, 
  ODataProperty, 
  EntityKey,
  Duration,
  ODataEntityResource,
  ODataEntitySetResource,
  ODataNavigationPropertyResource,
  ODataActionResource,
  ODataFunctionResource,
  HttpOptions
} from 'angular-odata';

//#region ODataApi Imports
import { BezeichnungDto } from '../Mza/Entities/Dtos/bezeichnungdto.entity';
//#endregion

@Injectable()
export class BezeichnungDtoService extends ODataEntityService<BezeichnungDto> {
  constructor(protected client: ODataClient) {
    super(client, 'BezeichnungDto', 'Mza.Entities.Dtos.BezeichnungDto');
  }

  
  
  //#region ODataApi Actions
  //#endregion
  //#region ODataApi Functions
  //#endregion
  //#region ODataApi Navigations
  //#endregion
}
